<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--alert box-->
        <v-alert text dense color="teal" icon="mdi-clock-fast" border="left" v-if="roleStatusmsg">
          <div v-for="(resp, i) in roleResponse" :key="i">
            {{ resp }}
          </div>
        </v-alert>
        <!--alert box end-->

        <!---datatable -->
        <v-data-table :headers="headers" :items="roles" :search="search" sort-by="name" class="elevation-1" primary>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>ROLE</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="primary" dark class="mb-2" to="/role/add">
                New Role
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editRole(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
        <!---datatable end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
export default {
  name: "Role",
  data: () => ({
    search: "",
    headers: [
      {
        text: "role",
        align: "start",
        sortable: true,
        value: "name"
      },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),

  computed: {
    ...mapGetters(["roleList", "roleStatus", "roleStatusResponse"]),
    roles: function () {
      return this.roleList;
    },
    roleStatusmsg: function () {
      return this.roleStatus === "success";
    },
    roleResponse: function () {
      return this.roleStatusResponse;
    }
  },

  watch: {},

  created() {
    this.fetchRoles();
  },

  methods: {
    ...mapActions(["fetchRoles"]),

    editRole(item) {
      const id = item.id;
      router.push({ path: `/role/edit/${id}` });
    }
  }
};
</script>
